const FAB_MENU_OPEN_EVENT = "hj:floating-menu-open";

export type FabMenuId = "create" | "navigation";

export const emitFabMenuOpened = (menuId: FabMenuId) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent<{ menuId: FabMenuId }>(FAB_MENU_OPEN_EVENT, {
      detail: { menuId },
    }),
  );
};

export const onFabMenuOpened = (callback: (menuId: FabMenuId) => void) => {
  if (typeof window === "undefined") {
    return () => undefined;
  }

  const listener = (event: Event) => {
    const customEvent = event as CustomEvent<{ menuId?: FabMenuId }>;
    const menuId = customEvent.detail?.menuId;

    if (!menuId) return;
    callback(menuId);
  };

  window.addEventListener(FAB_MENU_OPEN_EVENT, listener);
  return () => window.removeEventListener(FAB_MENU_OPEN_EVENT, listener);
};
